export const dnldVendorsList = (builder) => ({
    dnldVendorsList: builder.mutation({
      query: ({ vendor, enterprise_id, loggedin_user_id, user_type_id, }) => {
        return {
          url: '/download_vendor_list',
          method: 'GET',
          params: { vendor, enterprise_id, loggedin_user_id, user_type_id, },
          headers: {
            'Content-Type': 'text/csv',
          },
          responseHandler: (response)=>response.blob(),
        };
      },
    }),
  });
  